import * as types from './materialActionTypes';

const initialState = {
  materialData: null,
  materialList: null,
  error: {
    type: null,
    data: null,
  },
  createMaterialData: null,
  createMaterialError: null,
  updateMaterialData: null,
  updateMaterialError: null,
  deleteMaterialData: null,
  deleteMaterialError: null,
};

export const materialReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_MATERIAL_DATA:
      return {
        ...state,
        materialData: action.payload ? { ...action.payload } : null,
        materialList: action.payload?.MaterialList ? [...action.payload.MaterialList] : [],
      };
    case types.GET_MATERIAL_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_MATERIAL_ERROR,
          data: action.payload,
        },
      };
    case types.CREATE_MATERIAL_REQUEST:
      return {
        ...state,
        createMaterialError: null,
      };
    case types.CREATE_MATERIAL_DATA:
      return {
        ...state,
        createMaterialData: action.payload,
        createMaterialError: null,
      };
    case types.CREATE_MATERIAL_ERROR:
      return {
        ...state,
        createMaterialData: null,
        createMaterialError: action.payload,
      };
    case types.UPDATE_MATERIAL_REQUEST:
      return {
        ...state,
        updateMaterialError: null,
      };
    case types.UPDATE_MATERIAL_DATA:
      return {
        ...state,
        updateMaterialData: action.payload,
        updateMaterialError: null,
      };
    case types.UPDATE_MATERIAL_ERROR:
      return {
        ...state,
        updateMaterialData: null,
        updateMaterialError: action.payload,
      };
    case types.DELETE_MATERIAL_REQUEST:
      return {
        ...state,
        deleteMaterialError: null,
      };
    case types.DELETE_MATERIAL_DATA:
      return {
        ...state,
        deleteMaterialData: action.payload,
        deleteMaterialError: null,
      };
    case types.DELETE_MATERIAL_ERROR:
      return {
        ...state,
        deleteMaterialData: null,
        deleteMaterialError: action.payload,
      };
    default:
      return state;
  }
};